'use strict';

var SpillServiceDtdPaxGapAggregationFactory = function SpillServiceDtdPaxGapAggregationFactory(DataAggregationFactory) {
  function SpillServiceDtdPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'spill-service-dtd-pax-gap');
  }
  SpillServiceDtdPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  SpillServiceDtdPaxGapAggregation.constructor = SpillServiceDtdPaxGapAggregation;
  SpillServiceDtdPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  SpillServiceDtdPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedSpillPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var rangeName = 'range' + record.romTimeBucket;
      var service = record.service;
      var mapServiceIndex = map.indexOf(service);
      var spillPaxGap = {};
      if (mapServiceIndex === -1) {
        spillPaxGap[rangeName] = self.getMetricValue(record.spillPaxGap, metricsKeys, true);
        spillPaxGap.potentialRevenue = self.getMetricValue(record.potentialRevenue, metricsKeys, true);
        spillPaxGap.service = service;
        aggregatedSpillPaxGap.push(spillPaxGap);
        map.push(service);
      } else if (!aggregatedSpillPaxGap[mapServiceIndex][rangeName]) {
        aggregatedSpillPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
        aggregatedSpillPaxGap[mapServiceIndex][rangeName] = self.getMetricValue(record.spillPaxGap, metricsKeys, true);
      } else {
        aggregatedSpillPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
        aggregatedSpillPaxGap[mapServiceIndex][rangeName] += self.getMetricValue(record.spillPaxGap, metricsKeys, true);
      }
    }
    return self.sortBy(aggregatedSpillPaxGap, 'potentialRevenue', 'DESC');
  };
  return SpillServiceDtdPaxGapAggregation;
};
SpillServiceDtdPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = SpillServiceDtdPaxGapAggregationFactory;